export const GPT_ENDPOINT = '/gpt';

export const AIToolkitCacheKeys = Object.freeze({
  GetMyGptJobs: 'getMyGptJobs',
});
